import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsToolchainRoute: InvariantJiraRoute = {
	name: 'project-settings-software-toolchain-company-managed',
	path: '/jira/software/c/projects/:projectKey/settings/toolchain',
	exact: true,
};
